import { render, staticRenderFns } from "./advertising.vue?vue&type=template&id=a06108ae&scoped=true"
import script from "./advertising.vue?vue&type=script&lang=js"
export * from "./advertising.vue?vue&type=script&lang=js"
import style0 from "./advertising.vue?vue&type=style&index=0&id=a06108ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06108ae",
  null
  
)

export default component.exports